import ConsultaController from './consulta/consulta.controller';
import fretesFiltroDirective from './consulta/fretes/fretes-filtro.directive';
import fretesDetalheController from './consulta/fretes/detalhe.controller';
import fretesListagemController from './consulta/fretes/listagem.controller';
import empresasFiltroDirective from './consulta/empresas/empresas-filtro.directive';
import empresasDetalheController from './consulta/empresas/detalhe.controller';
import empresasListagemController from './consulta/empresas/listagem.controller';
import LoginController from './consulta/usuario/login.controller';
import CadastroController from './consulta/usuario/cadastro.controller';
import EsqueciSenhaController from './consulta/usuario/esqueci-senha.controller';
import PerfilController from './consulta/usuario/perfil.controller';
import conteudoConsultaDirective from './consulta/common/components/conteudo/conteudo-consulta.directive';
import listagemFretesConsultaDirective from './consulta/common/components/listagem-fretes/listagem-fretes.directive';

export default (ngModule: ng.IModule) => {
  ngModule
    .config(stateConfig)
    .run(tokenStatus)
    .controller('app.consulta.ConsultaController', ConsultaController)
    .controller('app.consulta.fretes.DetalheController', fretesDetalheController)
    .controller('app.consulta.fretes.ListagemController', fretesListagemController)
    .controller('app.consulta.empresas.DetalheController', empresasDetalheController)
    .controller('app.consulta.empresas.ListagemController', empresasListagemController)
    .controller('app.consulta.usuario.LoginController', LoginController)
    .controller('app.consulta.usuario.CadastroController', CadastroController)
    .controller('app.consulta.usuario.EsqueciSenhaController', EsqueciSenhaController)
    .controller('app.consulta.usuario.PerfilController', PerfilController)
    .value('STATE_DEFAULT', ['consulta.fretes.listagem', {}]);

  fretesFiltroDirective(ngModule);
  empresasFiltroDirective(ngModule);
  conteudoConsultaDirective(ngModule);
  listagemFretesConsultaDirective(ngModule);
};

/** @ngInject */
function stateConfig($urlRouterProvider, $stateProvider: any) {
  $urlRouterProvider.otherwise('/inicio');

  $stateProvider
    .state('app', {
      abstract: true,
      template: require('./app.html')
    })
    .state('app.inicio', {
      url: '/inicio',
      open: true,
      views: {
        conteudo: {
          template: require('./inicio/inicio.html')
        }
      }
    })
    .state('consulta', {
      url: '/consulta',
      abstract: true,
      template: require('./consulta/consulta.html'),
      controller: 'app.consulta.ConsultaController as vm'
    })
    .state('consulta.fretes', {
      url: '/fretes',
      abstract: true,
      views: {
        conteudo: {
          template: '<div ui-view="conteudo"></div>'
        }
      }
    })
    .state('consulta.fretes.listagem', {
      url: '/:index',
      open: true,
      views: {
        conteudo: {
          controller: 'app.consulta.fretes.ListagemController as vm',
          template: require('./consulta/fretes/listagem.html')
        }
      }
    })
    .state('consulta.fretes.detalhe', {
      url: '/:index/:nm_base/:cd_lote',
      views: {
        conteudo: {
          controller: 'app.consulta.fretes.DetalheController as vm',
          template: require('./consulta/fretes/detalhe.html')
        }
      }
    })
    .state('consulta.empresas', {
      url: '/empresas',
      abstract: true,
      views: {
        conteudo: {
          template: '<div ui-view="conteudo"></div>'
        }
      }
    })
    .state('consulta.empresas.listagem', {
      url: '/',
      open: true,
      views: {
        conteudo: {
          controller: 'app.consulta.empresas.ListagemController as vm',
          template: require('./consulta/empresas/listagem.html')
        }
      }
    })
    .state('consulta.empresas.detalhe', {
      url: '/:nm_base/:cd_pessoa',
      views: {
        conteudo: {
          controller: 'app.consulta.empresas.DetalheController as vm',
          template: require('./consulta/empresas/detalhe.html')
        }
      }
    })
    .state('consulta.sobre', {
      url: '/sobre',
      open: true,
      views: {
        conteudo: {
          template: require('./consulta/sobre/sobre.html')
        }
      }
    })
    .state('consulta.usuario', {
      url: '/usuario',
      abstract: true,
      views: {
        conteudo: {
          template: '<div ui-view="conteudo"></div>'
        }
      }
    })
    .state('consulta.usuario.login', {
      url: '/login',
      resolve: {login},
      open: true,
      views: {
        conteudo: {
          controller: 'app.consulta.usuario.LoginController as vm',
          template: require('./consulta/usuario/login.html')
        }
      }
    })
    .state('consulta.usuario.cadastro', {
      url: '/cadastro',
      open: true,
      resolve: {login},
      views: {
        conteudo: {
          controller: 'app.consulta.usuario.CadastroController as vm',
          template: require('./consulta/usuario/cadastro.html')
        }
      }
    })
    .state('consulta.usuario.esqueciSenha', {
      url: '/esqueci/minha/senha',
      open: true,
      resolve: {login},
      views: {
        conteudo: {
          controller: 'app.consulta.usuario.EsqueciSenhaController as vm',
          template: require('./consulta/usuario/esqueci-senha.html')
        }
      }
    })
    .state('consulta.usuario.perfil', {
      url: '/perfil',
      views: {
        conteudo: {
          controller: 'app.consulta.usuario.PerfilController as vm',
          template: require('./consulta/usuario/perfil.html')
        }
      }
    })
    .state('consulta.usuario.logout', {
      url: '/logout',
      resolve: {logout}
    });
}

/** @ngInject */
function tokenStatus(Usuario, Navegacao) {
  Usuario.tokenStatus();
  Navegacao.iniciar();
}

/** @ngInject */
function logout(Usuario) {
  Usuario.logout();
}

/** @ngInject */
function login(Usuario, $state, $timeout, STATE_DEFAULT) {
  if (Usuario.estaLogado()) {
    $timeout(() => $state.go(STATE_DEFAULT[0], STATE_DEFAULT[1]), 0);
  }
}



/** WEBPACK FOOTER **
 ** ./pages/pages.config.ts
 **/